export const googleMapsApiKey = process.env.VUE_APP_GOOGLE_MAPS;